import CrudActionSetBase from './CrudActionSetBase'

export class ReportDescriptionActionSet extends CrudActionSetBase('reportDescription'){}
export default new ReportDescriptionActionSet()